import PropTypes from 'prop-types';
import React from 'react';

const isMultiLineString = item =>
  (typeof item.value === 'string' || item.value instanceof String) &&
  item.value.split('\n').length > 1;

const MetaList = props => (
  <ul
    className="c-meta-list"
    {...(props.preferred_id && { id: props.preferred_id })}
  >
    {props.meta.map((item, key) => {
      const spanProps = { className: 'c-meta-list__value' };
      if (item.domId) {
        spanProps.id = item.domId;
      }

      return (
        <li key={key} className="c-meta-list__item">
          <strong className="c-meta-list__name">{item.name}</strong>
          <span {...spanProps}>
            {isMultiLineString(item)
              ? item.value.split('\n').map((text, index) => (
                  <span key={index}>
                    {text}
                    <br />
                  </span>
                ))
              : item.value}
          </span>
        </li>
      );
    })}
  </ul>
);

MetaList.propTypes = {
  preferred_id: PropTypes.string,
  meta: PropTypes.arrayOf(
    PropTypes.shape({
      domId: PropTypes.string,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.element,
      ]),
    })
  ),
};

MetaList.defaultProps = {
  meta: [],
};

export default MetaList;
